import type { TopAreaState } from '../models';

export const defaultState: TopAreaState = {
  backgroundImageUrl: '',
  backgroundVideoUrl: '',
  bannerHeadLineColor: '',
  bannerHeadlineText: '',
  breadcrumbs: [],
  categoryTitle: '',
  contentDescription: '',
  contentHeadline: '',
  isSubnavNested: false,
  pageId: '',
  pageType: '',
  subPages: [],
};
